import request from "./request";

/**分页获取活动列表 
 * @param {Number} uid
 * @param {String} usertoken
 * 
*/
export async function getMyAddresslist(uid, usertoken, page, limit) {
  return await request.get("/wxindex/wanbao/mylist.html", {
    params: {
      uid,
      usertoken,
      page,
      limit
    }
  });
}

/**填写激活码 */
export async function jihuoCode(uid, usertoken, code) {
  return await request.get("/wxindex/user/activecode.html", {
    params: {
      uid,
      usertoken,
      code
    }
  });
}

